export const getAuth = () => {
  const rootData = localStorage.getItem("persist:root")
  if (!rootData) return {}
  const auth = JSON.parse(rootData)?.auth
  if (!auth) return {}
  return JSON.parse(auth)
}

export const getAccessToken = () => {
  return localStorage.getItem("access_token")
}

export const setGlobalLoadingFalse = (callback) => {
  // const auth = getAuth()
  // auth.loading = false
  // localStorage.setItem('persist:root', JSON.stringify(auth))
  callback()
}

// 用戶閒置登出相關工具函數
const IDLE_TIMEOUT = 15 * 60 * 1000 // 15分鐘閒置時間（毫秒）
const LAST_ACTIVITY_KEY = "last_activity_timestamp"

/**
 * 記錄用戶最後活動時間
 */
export const updateLastActivity = () => {
  const currentTime = Date.now()
  localStorage.setItem(LAST_ACTIVITY_KEY, currentTime.toString())
  return currentTime
}

/**
 * 獲取最後活動時間戳
 */
export const getLastActivity = () => {
  const timestamp = localStorage.getItem(LAST_ACTIVITY_KEY)
  return timestamp ? parseInt(timestamp, 10) : null
}

/**
 * 清除最後活動時間戳
 */
export const clearLastActivity = () => {
  localStorage.removeItem(LAST_ACTIVITY_KEY)
}

/**
 * 計算閒置剩餘時間（毫秒）
 */
export const getRemainingIdleTime = () => {
  const lastActivity = getLastActivity()
  if (!lastActivity) return 0

  const now = Date.now()
  const elapsed = now - lastActivity
  const remaining = IDLE_TIMEOUT - elapsed

  return Math.max(0, remaining)
}

/**
 * 將毫秒轉換為倒計時格式 "H:MM:SS"
 */
export const formatCountdownTime = (milliseconds) => {
  if (milliseconds <= 0) return "0:00:00"

  const totalSeconds = Math.floor(milliseconds / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
}

/**
 * 檢查用戶是否已閒置
 */
export const isUserIdle = () => {
  const remainingTime = getRemainingIdleTime()
  const isIdle = remainingTime <= 0

  return isIdle
}

/**
 * 清除所有登入相關資料
 */
export const clearLoginData = () => {
  localStorage.removeItem("access_token")
  clearLastActivity()
}

/**
 * 初始化用戶活動監聽器
 * 監聽用戶在頁面上的操作，自動更新最後活動時間
 */
export const initActivityListener = () => {
  const activityEvents = [
    "mousedown",
    "mousemove",
    "keypress",
    "scroll",
    "touchstart",
    "click"
  ]

  const updateActivity = () => {
    updateLastActivity()
  }

  // 為每個事件類型添加監聽器
  activityEvents.forEach((event) => {
    document.addEventListener(event, updateActivity, true)
  })

  // 初始化最後活動時間
  updateLastActivity()

  // 返回清理函數
  return () => {
    activityEvents.forEach((event) => {
      document.removeEventListener(event, updateActivity, true)
    })
  }
}

export const getQgisURL = () => {
  switch (process.env.REACT_APP_API_URL) {
    case "https://avm-backend.houseplus.click/api":
      return "https://avm.houseplus.click"
    case "https://camaapi.land.moi.gov.tw/api":
      return "https://cama.moi.gov.tw"
  }
  return "https://avm.houseplus.click"
}
